<template>
    <div class="rivacypolicy">
        <el-row type="flex"
                class="row-bg"
                justify="center">
            <el-col :span="20">
                <div class="agreement">
                    <h1 class="page-title">《壹米滴答已收集个人信息清单》</h1>
                    <div style="text-indent: 1em;">更新时间： 2025年10月20日</div>
                    <div style="text-indent: 1em;">壹米滴答将尽全力保护您的个人安全，并保障您在个人信息处理过程中的相关权益。为了向您提供壹米滴答的业务功能，我们需要收集您在使用服务时主动提供/授权等方式产生的个人信息。以下我们将逐一说明收集情况，方便您快速查阅。</div>
                    <div style="text-indent: 1em;">.个人基本信息</div>
                    <div style="text-indent: 1em;">.网络身份标识信息</div>
                    <div style="text-indent: 1em;">.个人通信信息</div>
                    <div style="text-indent: 1em;">.个人财产信息</div>
                    <div style="text-indent: 1em;">.个人上网记录</div>
                    <div style="text-indent: 1em;">.个人常用设备信息</div>
                    <div style="text-indent: 1em;">.个人身份信息</div>
                    <div style="text-indent: 1em;">.个人位置信息</div>
                    <div style="text-indent: 1em;">.剪切板信息</div>
                    <div style="text-indent: 1em;">.个人其他信息</div>
                    <div class="title_level_1">个人基本信息</div>
                    <div>1.姓名</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">履行物流合同；实名认证；展示快件订单及运单信息；客服与售后；保障运行与交易安全；验证学生身份信息；验证收件人身份；设置代收货款的收款账号；向指定收款账号进行返款；代收货款的收款账号；向指定收款账号进行返款；个人月结客户使用代收货款的客户引入审核、款项支付及支付风控；理赔审核及赔付；开具发票；门店沟通；合作咨询；创建壹米滴答 ID ;行李托运；二维码寄件推广</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户寄递下单或使用快递服务时；用户首次进行寄递实名认证时；用户首次进行优待证实名认证时；用户申请理赔时;用户使用线上自助查询快件功能时；用户使用客户与售后服务时；判断运行与交易风险时；用户使用学生会员服务认证学生身份时；用户使用电子回单服务时；用户使用代收货款服务时；个人月结客户使用代收货款服务时；用户申请理赔时；用户申请开具发票时；用户提交合作咨询时；用户创建壹米滴答 ID 时;行李托运;参与二维码寄件推广时</div>
                            </div>
                        </div>
                    </div>
                    <div>2. 地址</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">履行物流合同；识别违法违禁品；展示快件订单及运单信息；客服与售后；保障运行与交易安全；月结客户对账；理赔赔付；开具发票；推荐附近服务点；创建壹米滴答 ID ；设置收件偏好；设置寄件偏好；个人月结客户使用代收货款的客户引入审核、款项支付及支付风控；行李托运</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户寄递下单或使用快递服务时;识别违法使用 场违禁品时；用户使用线上自助查询快件功能景时；用户使用客户与售后服务时；判断运行与交易风险时；用户使用月结客户对账服务时；用户申请支票线下赔付方式进行理赔时；用户申请开具发票时;用户创建壹米滴答 ID 时;用户使用服务偏好设置功能时;个人月结客户使用代收货款服务时；行李托运</div>
                            </div>
                        </div>
                    </div>
                    <div>3.电话号码（手机号码或固定电话号码）</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">注册和登录账号；履行物流合同；识别违法的违禁品；支付服务费用；展示快件订单及运单信息；查询快件订单及运单信息；客服与售后；保障运行与交易安全；联合登录；验证学生身份信息；验证收件人身份；设置银行卡收款账号；月结客户对账；理赔审核及赔付；税金账单查询；开具发票；门店沟通；开启寄件号码保护与黑名单；合作咨询；创建壹米滴答 ID ;确认用户操作真实性；与用户取得联系；发送消息和通知；提供招聘信息浏览功能；行李托运；二维码寄件推广</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户注册和登录账号时;用户寄递下单或使景用快递服务时；识别违法违禁品时；用户支付服务费用时；用户使用线上自助查询快件功能时；用户登录状态下使用壹米滴答官网线上自助查询功能时；用户使用客户与售后服务时；判断运行与交易风险时；用户通过第三方渠道登录壹米滴答 APP 时;用户使用学生会员服务认证学生身份时；用户使用拍照回传服务时；用户使用代收货款服务设置银行卡收款账号时；用户使用月结客户对账服务时；用户申请理赔时；通过理金卡向用户进行赔付时；用户申请开具发票时；用户开启寄件号码保护与黑名单功能时；用户提交合作咨询时；用户创建壹米滴答 ID 时；确认用户操作真实性时；与用户取得联系时；向用户推送消息和通知时；用户浏览壹米滴答招聘信息时；行李托运;参与二维码寄件推广时</div>
                            </div>
                        </div>
                    </div>
                    <div>4.电子邮箱地址</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">企业员工身份认证；发送发票</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户申请企业员工身份认证时;用户申请开具发票时</div>
                            </div>
                        </div>
                    </div>
                    <div>5.头像</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">完善账号信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户补充账号信息时</div>
                            </div>
                        </div>
                    </div>
                    <div>6.生日/出生日期</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">完善账号信息；个人月结客户使用代收货款的客户引入审核、款项支付及支付风控</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户补充账号信息时；个人月结客户使用代收货款服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>7.性别</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">完善账号信息；个人月结客户使用代收货款的客户引入审核、款项支付及支付风控</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户补充账号信息时;个人月结客户使用代收货款服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>8.地区</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">完善账号信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户补充账号信息时</div>
                            </div>
                        </div>
                    </div>
                    <div>9.学校</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">验证学生身份信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用学生会员服务认证学生身份时</div>
                            </div>
                        </div>
                    </div>
                    <div>10.学历</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">验证学生身份信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用学生会员服务认证学生身份时</div>
                            </div>
                        </div>
                    </div>
                    <div>11. 入学年份</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">验证学生身份信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用学生会员服务认证学生身份时</div>
                            </div>
                        </div>
                    </div>
                    <div>12.学制</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">验证学生身份信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用学生会员服务认证学生身份时</div>
                            </div>
                        </div>
                    </div>
                    <div>13.公司名称</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">补充运单信息；企业员工身份认证</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户寄递下单或使用快递服务时；用户申请企业员工身份认证时</div>
                            </div>
                        </div>
                    </div>
                    <div>14.个人签名（手写签名、电子签名)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">验证收件人身份；实名认证</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用拍照回传服务时；用户使用电子回单服务时；用户申请理赔时</div>
                            </div>
                        </div>
                    </div>
                    <div>15. 印章</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">验证收件人身份</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用拍照回传服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>16.通讯录</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">便捷填写运单信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用便捷下单功能时</div>
                            </div>
                        </div>
                    </div>
                    <div>17.国籍</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">个人月结客户使用代收货款的客户引入审核、款项支付及支付风控</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">个人月结客户使用代收货款服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>18.国家(实际居住地址)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">个人月结客户使用代收货款的客户引入审核、款项支付及支付风控</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">个人月结客户使用代收货款服务时</div>
                            </div>
                        </div>
                    </div>
                    <div class="title_level_1">网络身份标识信息</div>
                    <div>1.账号名称/昵称</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">客服与售后；完善账号信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用客户与售后服务时；用户补充账号信息时</div>
                            </div>
                        </div>
                    </div>
                    <div>2. IP 地址</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">查询快件订单及运单信息；保障运行与交易安全</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用壹米滴答官网线上自助查询功能时；判断运行与交易风险时</div>
                            </div>
                        </div>
                    </div>
                    <div>3.微信 openID</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">支付服务费用；保障运行与交易安全；验证学生身份信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户支付服务费用时；判断运行与交易风险时；用户使用学生会员服务认证学生身份时</div>
                            </div>
                        </div>
                    </div>
                    <div>4. 会员 ID</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">支付服务费用</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户支付服务费用时</div>
                            </div>
                        </div>
                    </div>
                    <div>5.第三方账号 ID</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">联合登录</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户通过第三方渠道登录壹米滴答 APP 时</div>
                            </div>
                        </div>
                    </div>
                    <div class="title_level_1">个人通信信息</div>
                    <div>1.通信记录和内容（含对话文本、通话录音、需要沟通的内容、咨询内容)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">提供即时通讯服务；客服与售后；保障运行与交易安全；理赔审核;提供即时通讯服务；门店沟通；合作咨询；壹米滴答"礼物寄递"增值服务</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户选择与快件收派人员进行在线对话时；用户使用客户与售后服务时；判断运行与交易风险时；判断用户理赔申请是否符合理赔要求时；用户选择与快件收派人员进行在线对话时;用户提交合作咨询时；用户使用语音录入祝福语及手动输入祝福语后智能生成语音的功能</div>
                            </div>
                        </div>
                    </div>
                    <div>2.收派件过程录音录像</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">客服与售后</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用客户与售后服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>3.推送消息文本</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">推送服务消息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">通过推送 SDK 向用户推送服务消息</div>
                            </div>
                        </div>
                    </div>
                    <div>4. 消息 ID</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">推送服务消息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">通过推送 SDK 向用户推送服务消息</div>
                            </div>
                        </div>
                    </div>
                    <div>5.软件使用记录</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">生成壹米滴答月报</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用壹米滴答用户报告功能时</div>
                            </div>
                        </div>
                    </div>
                    <div>6.推荐人工号</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">合作咨询</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户提交合作咨询时</div>
                            </div>
                        </div>
                    </div>
                    <div>7.备注（开票备注说明、合作备注)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">开具发票；合作咨询</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户申请开具发票时；用户提交合作咨询时</div>
                            </div>
                        </div>
                    </div>
                    <div class="title_level_1">个人财产信息</div>
                    <div>1.费用支付信息（运费、其他费用、付款方式)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">履行物流合同；展示快件订单及运单信息；客服与售后</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户寄递下单或使用快递服务时；用户使用线上自助查询快件功能时；用户使用客户与售后服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>2.保价信息（物品价值、保价金额）</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">展示快件订单及运单信息；客服与售后</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用线上自助查询快件功能时；用户使用客户与售后服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>3.签收信息</div>
                    <div>（签收时间、签收方式、签收底单)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">展示快件订单及运单信息；客服与售后</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用线上自助查询快件功能时；用户使用客户与售后服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>4.交易金额（服务费用、代收金额、月结订单费用金额、理赔金额、货币类型、充值金额）</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">支付服务费用；向指定收款账号进行返款；月结客户对账；理赔申请及赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户支付服务费用时；用户使用代收货款服务时;用户使用月结客户使用对账服务时；用户申请理赔时</div>
                            </div>
                        </div>
                    </div>
                    <div>5.支付订单号</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">支付服务费用</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户支付服务费用时</div>
                            </div>
                        </div>
                    </div>
                    <div>6.银行名称（转账收款人银行、转账开户支行、开户银行)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">设置银行卡返款账号；向指定返款账号进行返款；个人月结客户使用代收货款的客户引入审核、款项支付及支付风控；理赔赔付；开具发票</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用代收货款服务时；个人月结客户使用代收货款服务时；通过银行向用户进行赔付时；用户申请开具发票时</div>
                            </div>
                        </div>
                    </div>
                    <div>7.银行代码</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">理赔赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">通过银行向用户进行赔付时</div>
                            </div>
                        </div>
                    </div>
                    <div>8.转账收款人省市</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">理赔赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">通过银行向用户进行赔付时</div>
                            </div>
                        </div>
                    </div>
                    <div>9.转账交易类型</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">理赔赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">通过银行向用户进行赔付时</div>
                            </div>
                        </div>
                    </div>
                    <div>10.支票收件人省市</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">理赔赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">通过支票向用户进行赔付时</div>
                            </div>
                        </div>
                    </div>
                    <div>11.支票交易类别</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">理赔赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">通过支票向用户进行赔付时</div>
                            </div>
                        </div>
                    </div>
                    <div>12.托寄物品信息（托寄物种类、重量、体积、件数、包装相关照片、数量)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">履行物流合同；识别违法违禁品；展示快件订单及运单信息；客服与售后；月结客户对账；理赔申请；生成壹米滴答月报</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户寄递下单或使用快递服务时；识别违法违禁品时；用户使用线上自助查询快件功能时；用户使用客户与售后服务时；用户使用月结客户使用对账服务时；用户申请理赔时；用户使用壹米滴答用户报告功能时</div>
                            </div>
                        </div>
                    </div>
                    <div>13.消费账单</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">月结客户对账</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用月结客户使用对账服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>14. 消费明细</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">月结客户对账</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用月结客户使用对账服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>15.支付宝账号</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">设置支付宝返款账号；向指定返款账号进行返款；理赔支付宝赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用代收货款服务时；通过支付宝向用户进行赔付时</div>
                            </div>
                        </div>
                    </div>
                    <div>16.银行卡号/银行账号</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">设置银行卡返款账号;个人月结客户使用代收货款的客户引入审核、款项支付及支付风控；向指定返款账号进行返款；理赔银行卡赔付；开具发票</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用代收货款服务时；个人月结客户使用代收货款服务时；通过银行向用户进行赔付时；用户申请开具发票时</div>
                            </div>
                        </div>
                    </div>
                    <div>17.运单信息（寄件时间、月结账号、收寄件网点、运单扫描件或同等文件、快递单号)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">理赔审核及赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户申请理赔时</div>
                            </div>
                        </div>
                    </div>
                    <div>18.物品价值信息（声明价值、价值证明)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">理赔申请、审核及赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户申请理赔时</div>
                            </div>
                        </div>
                    </div>
                    <div>19.受损及赔偿材料[索赔函或同等文件（如通话录音等)、银行汇款回执扫描件、损失相关证明材料、检测报告扫描件（如有）、交通事故责任认定书扫描件（如有)、受损照片、报警回执扫描件(如有)、客户投诉日期、索赔金额、理赔原因、调查描述、报案人名称与电话号码、出险地点、预估损失金额、附件照片]</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">理赔审核及赔付</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户申请理赔时</div>
                            </div>
                        </div>
                    </div>
                    <div>20.发票</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">清关</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">为用户提供货物进出口通关服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>21.清关单证</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">清关</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">为用户提供货物进出口通关服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>22.购物小票</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">清关</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">为用户提供货物进出口通关服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>23.货物异常情况说明</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">清关</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">为用户提供货物进出口通关服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>24. 税金</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">税金账单查询</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户查询税金时</div>
                            </div>
                        </div>
                    </div>
                    <div>25.货物金额</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">税金账单查询</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户查询税金时</div>
                            </div>
                        </div>
                    </div>
                    <div>26.报关金额</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">税金账单查询</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户查询税金时</div>
                            </div>
                        </div>
                    </div>
                    <div class="title_level_1">个人上网记录</div>
                    <div>1.操作日志</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">保障运行与交易安全</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">判断运行与交易风险时</div>
                            </div>
                        </div>
                    </div>
                    <div>2.评价信息(满意度结果、不满意原因及满意原因)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">客户与售后</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">向用户进行满意度调研时</div>
                            </div>
                        </div>
                    </div>
                    <div>3.偏好信息（收件偏好、寄件偏好、接收消息偏好、服务勿扰偏好、回访服务设置)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">根据客户偏好提供个性化服务</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用服务偏好设置功能时</div>
                            </div>
                        </div>
                    </div>
                    <div>4. 会员动态</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">生成壹米滴答月报</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用壹米滴答用户报告功能时</div>
                            </div>
                        </div>
                    </div>
                    <div class="title_level_1">个人常用设备信息</div>
                    <div>1.设备识别码</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">查询快件订单及运单信息；推送服务消息；保障运行与交易安全</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用壹米滴答官网线上自助查询功能时；通过推送 SDK 向用户推送服务消息时；判断运行与交易风险时</div>
                            </div>
                        </div>
                    </div>
                    <div>2. 已安装应用列表</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">保障运行与交易安全</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">判断运行与交易风险时</div>
                            </div>
                        </div>
                    </div>
                    <div>3.运营商信息</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">保障运行与交易安全</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">判断运行与交易风险时</div>
                            </div>
                        </div>
                    </div>
                    <div class="title_level_1">个人身份信息</div>
                    <div>1.身份证件号码</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">实名认证；验证学生身份信息；验证收件人身份；设置银行卡返款账号；个人月结客户使用代收货款的客户引入审核、款项支付及支付风控</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户首次进行寄递实名认证时;用户首次进行优待证实名认证时；用户申请理赔时；用户使用学生会员服务认证学生身份时；用户使用拍照回传服务时；用户使用电子回单服务时；用户使用代收货款服务设置返款账号时；个人月结客户使用代收货款服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>2.身份证件图片</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">实名认证；理赔申请；清关</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户首次进行优待证实名认证时；用户申请理赔时；为用户提供货物进出口通关服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>3.护照图片</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">实名认证</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用行李托运功能进行实名认证时用于 OCR 识别</div>
                            </div>
                        </div>
                    </div>
                    <div>4.护照号码</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">实名认证</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用行李托运功能进行实名认证时通过 OCR 识别填入</div>
                            </div>
                        </div>
                    </div>
                    <div class="title_level_1">个人位置信息</div>
                    <div>1.精确定位信息</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">推荐附近服务点；便捷填写运单信息</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户查询附近服务点时</div>
                            </div>
                        </div>
                    </div>
                    <div class="title_level_1">其他个人信息</div>
                    <div>1.其他图片及单据</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">展示快件订单及运单信息；客服与售后</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用线上自助查询快件功能时；用户使用客户与售后服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>2.服务使用记录（寄件量、收件量、日均预估件量、运单记录）</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">生成壹米滴答月报；合作咨询；展示二维码寄件推广历史记录</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用壹米滴答用户报告服务时;用户提交合作咨询时;参与二维码寄件推广时</div>
                            </div>
                        </div>
                    </div>
                    <div>3.理赔历史</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">理赔审核</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">判断用户理赔申请是否符合理赔要求时</div>
                            </div>
                        </div>
                    </div>
                    <div>4.投诉记录</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">客服与售后</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">用户使用客户与售后服务时</div>
                            </div>
                        </div>
                    </div>
                    <div>5.经营信息（店铺名称、经营范围、经营地址、营业执照、门头招牌、推荐工号、身份类型)</div>
                    <div class="table-container">
                        <div class="info-table">
                            <div class="table-row">
                                <div class="label-cell">使用目的</div>
                                <div class="content-cell">确认是否具备参与推广活动的资格以及后续生成宣传物料及寄件地址选择</div>
                            </div>
                            <div class="table-row">
                                <div class="label-cell">使用场景</div>
                                <div class="content-cell">参与二维码寄件推广</div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 20px;"></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    watch: {},
    created() {},
    methods: {}
};
</script>

<style scoped lang="scss">
.rivacypolicy {
    padding-bottom: 50px;
    background-color: #fff;
    .agreement {
        padding: 20px;
        height: 100%;
        font-size: 14px;
        line-height: 1.8;
        .page-title {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin: 0 0 30px 0;
            padding: 20px 0;
            border-bottom: 2px solid #e0e0e0;
            width: 100%;
        }
        div {
            text-indent: 1em;
            margin-bottom: 10px;
            color: #333;
        }
        .title_level_1 {
            text-indent: 0 !important;
            font-size: 18px;
            line-height: 40px;
            font-weight: bold;
            margin-top: 20px;
            margin-bottom: 10px;
        }
        .table-container {
            overflow-x: auto;
            margin: 20px 0;
        }
        .info-table {
            width: calc(100% - 4px);
            border: 2px solid #d0d0d0;
            border-collapse: collapse;
            background-color: #fff;
        }
        .table-row {
            display: flex;
            border-bottom: 2px solid #d0d0d0;
            &:last-child {
                border-bottom: none;
            }
        }
        .label-cell {
            width: 200px;
            min-width: 200px;
            padding: 20px 15px;
            border-right: 2px solid #d0d0d0;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            line-height: 1.6;
            word-break: break-all;
            background-color: #f5f5f5;
            font-weight: bold;
        }
        .content-cell {
            flex: 1;
            padding: 10px 15px;
            text-align: left;
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 1.6;
            word-break: break-all;
        }
    }
}
</style>

